import { formatsFields } from 'utils/formats';
import { IGetFormatedCpfCnpjParams } from './interfaces';

export const getFormatedCpfCnpjValue = ({
  formatedType,
  cpfCnpj,
}: IGetFormatedCpfCnpjParams): string => {
  let numberCount = 0;
  return formatsFields[formatedType]
    .split('')
    .reduce((formatedValue: string, current: string) => {
      let value = current;
      if (current === '#') {
        value = cpfCnpj[numberCount] || '_';
        numberCount++;
      }
      return `${formatedValue}${value}`;
    }, '');
};
